<template>
  <v-container fluid fill-height class="pa-2">
    <v-row class="page">
      <v-col>
        <v-tabs
          v-model="tab"
        >
          <v-tab
            v-for="item in filteredVideoSources"
            :key="item.tab"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="item in filteredVideoSources"
            :key="item.tab"
          >
            <v-carousel
              height="80vh"
              hide-delimiter-background
              show-arrows-on-hover
            >
              <v-carousel-item
                v-for="(slide, i) in item.content"
                :key="i"
              >
                <v-sheet
                  height="100%"
                >
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center"
                  >
                    <DeviceImage360 :image="slide"></DeviceImage360>
                  </v-row>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import DeviceImage360 from '@/components/Device/DeviceImage360.vue';

const SUBSCRIPTION_VIDEOSOURCES = gql`
subscription get_videosource_files {
  files(
    where: {
      videoSource: {
        _is_null: false
      }
    }
  ) {
    id
    url
    videoSource
  }
}
`;
export default {
  name: 'Content',
  data() {
    return {
      videoSources: [],
      tab: null,
    };
  },
  components: {
    DeviceImage360,
  },
  computed: {
    filteredVideoSources() {
      const arr = this.videoSources.map((file) => file.videoSource);
      const tabs = Array.from(new Set(arr));
      const items = tabs.map((tab) => {
        let content = this.videoSources.filter((item) => item.videoSource === tab);
        content = content.sort(this.compare);
        return { tab, content };
      });
      return items;
    },
  },
  methods: {
    compare(a, b) {
      const bandA = a.url.toUpperCase();
      const bandB = b.url.toUpperCase();

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
  },
  apollo: {
    // Subscriptions
    $subscribe: {
      // When a user is added
      videoSources: {
        query: SUBSCRIPTION_VIDEOSOURCES,
        // Result hook
        result(data) {
          // Let's update the local data
          this.videoSources = data.data.files;
        },
      },
    },
  },
};
</script>

<style scoped>
.page {
  height: 100vh;
}
</style>
